import { CONFIG } from './config'

export const DEFS: { [key: string]: string } = {
    "acessu": "s/he moves abruptly to different location, position, etc.",
    "ahqiku": "s/he is stern, severe, strict",
    "akawhu": "tent caterpillar, army worm",
    "akehsu": "s/he is the same in amount or number as previously",
    "akiyan": "look at h/! look at them!",
    "akolus": "eastern skunk cabbage",
    "akuwiw": "extending or moving behind or in back of; extending or moving out of view or out of sight",
    "alutsu": "s/he is brunette, has dark hair",
    "amakon": "fishing tackle",
    "amante": "I wish that ..., I hope that ...",
    "amewin": "fisherman",
    "amihku": "s/he gets up",
    "amoniw": "detouring around, bypassing;  around in a circle; encircling, orbiting",
    "amuwes": "bee",
    "anelsu": "s/he atones, is contrite, becomes humble",
    "ankusu": "s/he sells, buys",
    "ankuwe": "s/he buys or sells",
    "ansahc": "as if",
    "apahqe": "s/he is back from having cooked",
    "apalke": "s/he is back from digging",
    "apamke": "s/he is back from having played game; s/he is back from having run for office , is back from having competed",
    "apc-oc": "again in the future;  good-bye, farewell",
    "apciye": "s/he, it keeps going, is still going",
    "apenke": "s/he pays",
    "apkamu": "s/he has come back having gained weight",
    "aposes": "officer",
    "apsiqe": "s/he has small face",
    "apsoqe": "s/he is back from having checked traps",
    "aputte": "it is turned inside-out, is folded back",
    "aqamel": "there is more of h/",
    "aqamiw": "more, more so",
    "asakon": "there is mild weather in winter, a thaw, causing fallen snow to become moist",
    "aselis": "angel, cherub",
    "asihta": "s/he sees what will happen to self in future, s/he has premonition;",
    "asitiw": "in the distant past, way back then",
    "asuwiw": "at an angle, diagonally, obliquely, crooked",
    "athasu": "it is tattooed",
    "atkiqe": "s/he has wrinkles or crow's feet on face",
    "atpehe": "the level of the tide changes",
    "atqepu": "s/he changes seat, moves to another seat; s/he changes position in seat",
    "atsewe": "s/he changes clothes",
    "awisiw": "seldom, rarely",
    "awiska": "s/he seldom dances",
    "awskol": "it would have to ...",
    "cahahq": "tree-stump; butt end of log",
    "cahqal": "porpoise tail fin or dorsal fin",
    "cakola": "juggler",
    "camsis": "charm basket",
    "caqahk": "rust",
    "cawota": "chowder",
    "cehcis": "vein",
    "cehkit": "jacket",
    "cehqan": "day breaks, dawn comes",
    "cehqot": "it is daybreak, is dawn",
    "'cehtu": "s/he hemorrhages through nose and mouth",
    "cekpat": "jackpot",
    "celiye": "s/he is helpless",
    "celopu": "s/he is in out-of-the-way place, is inaccessible",
    "'cessu": "s/he, it comes from there",
    "cikiye": "s/he quiets down",
    "cikopu": "s/he is silent, sits silently",
    "cileyu": "s/he, it is bruised",
    "cilopu": "s/he leaves mark by sitting",
    "cimoli": "chimney, smokestack",
    "cineyu": "s/he, it is low",
    "ciniye": "it is low, goes along at low altitude",
    "cipqam": "s/he has nightmare",
    "cipuwe": "h/ hair looks messy",
    "ckuwiw": "toward here; recently",
    "ckuwye": "s/he, it comes toward here",
    "cocahq": "soul, spirit",
    "cokahk": "yikes!, whoops!, ugh!, yuck!, etc.",
    "cucuhc": "insect, bug",
    "cuspes": "Atlantic harbor porpoise",
    "ecuwiw": "s/he hedges bets;  s/he antes up",
    "ehetsu": "s/he hesitates out of shyness",
    "ehqame": "s/he stops fishing",
    "ehqamu": "s/he, it stops moving through the air",
    "ehqiye": "s/he, it stops going there",
    "ekhute": "it hangs, hangs down, dangles",
    "eleyik": "event, occurrence, happening; truth, the way it is",
    "elikit": "the way s/he looks; s/he is ugly",
    "emekte": "it is below, it is at the bottom, it is downstairs",
    "empaye": "umpire",
    "enawke": "s/he races",
    "epaspe": "s/he, it is half full of liquid",
    "eqhike": "s/he stops shooting",
    "eqpayu": "s/he stops being afraid",
    "eqqile": "s/he stops barking",
    "escoqe": "water or dampness comes through h/, it",
    "esoton": "it is chilled all the way through;  cold comes through it",
    "espehe": "it leaks through with the liquid accumulating",
    "espons": "raccoon",
    "esqopu": "s/he is last one left, is left over",
    "esuhse": "s/he walks through",
    "esuwiw": "back and forth",
    "ewepiw": "up, upward, up above",
    "eweppu": "s/he sits upright, sits up above",
    "ewepte": "it is up",
    "hankan": "sturdy grass used for basket handles, in craftwork, etc.",
    "i-pesq": "one to each",
    "imiyan": "there is praying or prayer service, there is mass, there is church service",
    "ipakte": "hey!, listen!, look!",
    "ipocol": "because; because of course",
    "itasik": "what is said; expression, saying",
    "kaciye": "s/he, it moves out of sight",
    "kakehs": "many times, several times;  many, several",
    "'kalal": "s/he hides h/",
    "'kaney": "something old, antique, antiquated, archaic, etc.",
    "kapsis": "cup",
    "kat-cu": "better not; don't!",
    "kat-op": "would not",
    "kat-te": "not, not at all",
    "katasu": "it is hidden or concealed; it is clandestine",
    "'katun": "s/he hides it, conceals it",
    "kaweyu": "s/he, it is rough to the touch, is rough in texture",
    "kecawt": "street corner",
    "kehcap": "ketchup",
    "kehson": "it is so much, there is so much of it;  they are so many, there are so many of them",
    "kehtol": "of course, sure enough",
    "kekesk": "a little, a little bit; slightly",
    "'kekiw": "all day",
    "kensis": "can",
    "keptin": "captain; tribal council-member, official equivalent to kinap",
    "kespiw": "unintentionally;  accidentally",
    "khakon": "door",
    "kihkan": "garden",
    "kinapu": "s/he looks intently, glares",
    "kineyu": "s/he, it is sharp",
    "kinkil": "s/he is big, bulky",
    "kipiye": "s/he falls over",
    "kiposs": "orphan",
    "kisacu": "s/he is ready",
    "kisamu": "s/he fell down, fell on the ground or floor",
    "kiseyu": "s/he is ready",
    "kisiku": "s/he is full-grown, grown up, adult",
    "kiskot": "it is low tide;  it is a day, the day is ..., the weather is ...",
    "kisopu": "s/he sat down, can sit down;  s/he sat up, can sit up;  s/he is done cooking, is ready to eat",
    "kisuhs": "sun, moon; month",
    "kiwahq": "ice giant",
    "kiwhos": "muskrat",
    "kolahk": "clock, timepiece",
    "kolike": "s/he hogs food, money, supplies, etc.",
    "kolocu": "s/he freezes, is frozen",
    "kolomu": "s/he, it sticks, is stuck, is caught;  s/he alights and holds on",
    "kolopu": "s/he is on, stuck on; s/he is in hock, still in hock",
    "kolusu": "s/he speaks",
    "komoku": "s/he dives",
    "kosqep": "handkerchief",
    "kpoton": "it is frozen shut, is frozen over; the entrance to it is frozen shut",
    "ksaccu": "s/he stays longer because of the cold",
    "ksahke": "it is steep hill",
    "ksaqhe": "it has strong scent or odor",
    "ksatke": "s/he likes the place so much that s/he stays longer",
    "ksentu": "s/he sings as s/he enters",
    "ksessu": "it hurts",
    "ksewse": "s/he walks in;  s/he rises farther to the north each day",
    "ksicon": "it is badly scratched",
    "kskeku": "s/he is wide, is broad",
    "kskeyu": "s/he, it is wide, is broad",
    "ksotte": "it is dark in color",
    "ksuwye": "s/he goes about openly",
    "ktahpe": "s/he is helpless, is in hopeless or dangerous situation; s/he is held accountable or responsible, is blamed",
    "ktamke": "there is sand or gravel on or mixed in the snow; there are gravelly patches showing through the snow",
    "ktokan": "there is big dance",
    "ktopeq": "spring; cold water",
    "ktuwan": "big log for fire",
    "kuhucu": "s/he feels cold",
    "kuspem": "lake",
    "kuwhas": "hawk",
    "kuwocu": "s/he feels cold",
    "lahkap": "cellar, basement",
    "lakiye": "s/he, it is bent thus, curves thus",
    "lamsoq": "attic; closet",
    "lapesu": "s/he makes that much money; h/ wage or salary is so much",
    "lapiqe": "s/he sees something; s/he pictures something in mind",
    "latpep": "bandanna, kerchief, headband",
    "latuwe": "s/he climbs, clambers",
    "lawotu": "s/he, it costs that much, is worth so much",
    "lellut": "rail",
    "lelomu": "s/he smiles or laughs thus",
    "lemons": "lemon",
    "lesson": "it happens; something happens to it",
    "likson": "it looks thus, it is such and such a kind",
    "liqehe": "s/he, it rolls thus, there",
    "liqewu": "s/he makes such a facial expression",
    "litpot": "it happens thus",
    "liwisu": "s/he is named ..., is called ...; h/ name is ...",
    "lontoq": "fresh water, lake water; body of fresh water",
    "lossin": "s/he lies down; s/he is lying down;  she is confined",
    "luhkan": "it is a work week ; it is a weekday",
    "macehe": "s/he leaves, departs; s/he goes home",
    "maceku": "s/he grows up;  s/he starts to grow",
    "macepu": "s/he extends from there, exists from there onward, is in place beginning then",
    "mahkut": "dress",
    "mahqan": "sap of sugar maple; maple syrup or sugar; anything sweet",
    "mahsus": "fiddlehead",
    "maleyu": "s/he is lazy",
    "malkot": "the tide is not particularly high or low",
    "malsan": "shopkeeper",
    "malsom": "wolf; name of Koluskap's twin brother",
    "mapput": "baseboard, mopboard",
    "maqehe": "s/he, it comes together",
    "mastot": "mustard",
    "mawehe": "it comes together",
    "mawema": "s/he calls them together, s/he convokes them",
    "mawiye": "s/he, it comes together, gathers, collects;  s/he takes part in gathering;  they come together, they go as group",
    "mawopu": "s/he takes part in meeting or gathering;  they sit together, they are positioned together; they meet , they collect , they are a group or coalition",
    "mec-al": "approximately, about",
    "mehcis": "match, lighter",
    "mehciw": "ending, terminating, concluding, finishing; having ended, terminated, concluded, finished",
    "memiye": "s/he fits through",
    "memopu": "s/he fits in place, there is room for h/; s/he has had enough of sitting",
    "meskat": "why not",
    "methom": "s/he has run out",
    "metsiw": "it is late",
    "micasu": "it is eaten, is edible",
    "miciye": "s/he gets in the way of something or someone",
    "mihkom": "Mi'kmaq",
    "milapu": "s/he looks all around",
    "miliye": "s/he goes to many different places",
    "milopu": "s/he sits in different positions, shifts from one position to another",
    "miluwe": "s/he gives, donates",
    "mimeku": "h/ clothing is covered with grease;  s/he is greasy",
    "mimhal": "s/he oils or greases h/ using brush, paper, etc.",
    "mimiqe": "h/ face is shiny",
    "minuwe": "s/he catches cold again",
    "miskiw": "often, sometimes",
    "miskot": "it is plentiful, there is enough of it to go around",
    "mistoq": "wadding",
    "mitopu": "s/he is in the way, obstructs, sits in the way",
    "mocamu": "it goes off course;  s/he is a ball",
    "mocehs": "article of clothing, garment",
    "moceyu": "s/he is clumsy",
    "mocone": "s/he holds bad hand",
    "mocuwe": "s/he has messy or disheveled hair",
    "mokahk": "striped bass, sea bass, black bass",
    "molaqs": "milk",
    "monamu": "s/he, it falls off, flies off",
    "moneyu": "s/he, it has become detached, is not attached",
    "monihq": "island",
    "moniku": "s/he is crowded out;  they grow in scattered clumps",
    "moqisu": "s/he swells; s/he is swollen",
    "moshun": "h/ heart",
    "mosqon": "h/ chest",
    "motaqs": "woman friend of a woman; lady, my dear",
    "motehe": "s/he is heard going",
    "moteka": "s/he is heard dancing",
    "mulkew": "deep, in bottom of hole",
    "musawe": "s/he cuts hair; s/he barbers",
    "musqon": "clear sky, blue sky",
    "musqot": "it clears",
    "mususu": "s/he cuts own hair",
    "muwisu": "s/he picks or gathers berries",
    "nahkaw": "down, downward; down to lower position",
    "nakaku": "s/he grows slowly",
    "nakayu": "s/he is slow",
    "nakehe": "s/he goes slowly",
    "namopa": "number, numeral; telephone number",
    "nanatq": "five-hundred",
    "napaha": "rooster",
    "naphal": "s/he strings h/",
    "nasqam": "s/he sleeps in someone else's house so that person won't be alone",
    "natame": "s/he goes to fish",
    "nathom": "s/he goes to swim",
    "nehtaw": "if; in case",
    "nemaht": "to or at a destination or starting-point;  at, in, to my house",
    "nenhiw": "somehow; in some unknown way; just by chance",
    "neqhom": "s/he coughs",
    "neqiye": "s/he goes under",
    "newatq": "four-hundred",
    "newwok": "there are four of them, they are group of four",
    "nickiw": "it heals",
    "nikimu": "s/he growls",
    "nipehe": "s/he goes out at night, travels at night; s/he stays out late at night",
    "nipuhu": "s/he is married",
    "nisatq": "two-hundred",
    "nit-te": "that, that one",
    "niweyu": "it is arid, is dry",
    "nokasu": "s/he is afraid",
    "nokocu": "s/he has a set way of life; h/ ways are set",
    "nomehs": "fish",
    "nunuwe": "she nurses or breast-feeds baby; she is wet-nurse",
    "nusapu": "s/he looks around to see what's going on, noses around, observes, browses, wanders around looking",
    "nusesq": "she-bear",
    "nuskiw": "on top of;  on top of that, what's more",
    "nutapu": "s/he sits at low level, has low position",
    "nutasu": "s/he hears self",
    "nutehe": "s/he goes out, comes out",
    "nutkat": "dancer",
    "nutoma": "s/he hears",
    "okamiw": "across, on the other side",
    "okamok": "across, on the other side",
    "okepse": "s/he is deaf",
    "okonse": "s/he gathers driftwood",
    "olcoke": "it is that soiled, is that dirty",
    "olhoma": "s/he behaves thus",
    "olhute": "it runs thus, its course is ...",
    "olkamu": "s/he weighs so much",
    "olliqe": "s/he is right there, stays right there",
    "olomel": "s/he increases in quantity;  they increase in number",
    "olomiw": "away",
    "oloqiw": "in that direction, toward; in that way",
    "olqepu": "s/he sits thus",
    "olsawe": "s/he cuts thus",
    "olsewe": "s/he dresses thus",
    "olsite": "h/ foot is like that; h/ feet are like that",
    "on-ote": "only",
    "opanke": "s/he mixes bread dough",
    "opessu": "s/he sits down quickly",
    "oqassu": "s/he lands, arrives by boat ashore where water is shallow , s/he runs canoe ashore",
    "oqimut": "lagoon, bay; sheltered harbor, port",
    "oqiton": "canoe",
    "osassu": "it recoils, has a kick to it",
    "osehta": "s/he steadies or braces for accurate aim",
    "osipis": "lamb",
    "otoqon": "it is in there;  it is loaded",
    "otukke": "s/he hunts deer",
    "pahkak": "in back yard, out back; behind",
    "paksis": "box",
    "paniqe": "h/ face is uncovered or exposed",
    "paniye": "s/he, it comes to open place",
    "papkan": "popcorn",
    "papkiw": "downriver, downstream; downhill",
    "pasocu": "s/he is frozen in thick layer",
    "patosu": "s/he chokes, gets dizzy and sick from inhaling smoke",
    "pciliw": "especially",
    "peciye": "s/he, it arrives, reaches there",
    "pectik": "bat",
    "pehqey": "fresh food obtained when in season",
    "penocu": "banjo",
    "pesqon": "one",
    "petamu": "s/he, it falls or flies to there",
    "pethom": "s/he approaches or arrives swimming, swims here",
    "petkil": "s/he reaches a size",
    "petopu": "s/he extends to there",
    "petqil": "quilt, blanket",
    "petson": "it builds up, picks up; wind comes up",
    "petute": "s/he moves to here, into here",
    "pihcis": "peach",
    "pihcol": "pitcher, jug",
    "pihqat": "Pequot",
    "pihtal": "lion",
    "pikeks": "pickax",
    "pikews": "vest",
    "piksap": "pork soup, pork broth",
    "piksey": "pork",
    "pikuwe": "s/he has thick coat of fur",
    "pilasq": "paper",
    "pileyu": "s/he, it is new",
    "piltal": "lead",
    "pinsis": "pin",
    "pipiqe": "s/he plays wind instrument",
    "piqeku": "s/he, it is hollow",
    "piqosq": "pith",
    "pisamu": "s/he, it falls in",
    "pisapu": "s/he looks inside, peers into",
    "pisiye": "s/he, it goes in or comes in",
    "pisute": "s/he moves in",
    "piwsoq": "piece of firewood; piece of wood",
    "piyehs": "hair",
    "pkiksu": "s/he is burned, scorched",
    "pkikte": "it is burned, scorched",
    "pkonke": "s/he selects, chooses, picks",
    "pkoson": "shoe",
    "pocokk": "splat!",
    "polams": "plum",
    "poluns": "prune",
    "pomamu": "s/he goes on falling; s/he, it continues on original course",
    "pomiku": "s/he is growing, keeps growing",
    "pomiye": "s/he goes along",
    "pomute": "s/he is moving belongings or household",
    "poskat": "it holds so much",
    "posoqp": "drop of water, raindrop",
    "posson": "ice floe, reef of ice",
    "pqahsu": "s/he shines red",
    "pqahtu": "s/he earns",
    "pqatpe": "s/he has red hair, is redhead",
    "pqessu": "h/ skin is red",
    "pqomis": "hailstone, icicle",
    "psekon": "it is continuous sheet, is seamless",
    "psewis": "springtail, snow flea; fruit fly",
    "psihtu": "s/he has contagious disease",
    "psikiw": "splitting",
    "psimsu": "s/he tells on self, confesses",
    "pskasu": "it is found",
    "pskehe": "s/he turns to one side while moving along, turns off onto side road, changes direction in which s/he is going",
    "pskeht": "root of white or yellow water lily",
    "pskihq": "blade of grass, strand of hay, straw",
    "pskomu": "s/he escapes, breaks loose",
    "psonpe": "s/he, it is full of liquid",
    "psonte": "it is full",
    "psqeyu": "s/he, it is intact, is whole, is not smashed;  s/he is healthy",
    "psuhun": "heart",
    "psuwis": "cat",
    "ptohom": "s/he hooks fish",
    "ptokka": "s/he turns to side while dancing",
    "ptoqap": "bag",
    "puhkes": "maggot",
    "puhsis": "bow",
    "puhtay": "bottle",
    "puktes": "bubble",
    "pulsis": "small bowl",
    "'punal": "s/he puts h/, places h/",
    "punasu": "it is put there, is installed; it is donated",
    "punawe": "s/he sets traps",
    "puniwi": "of winter",
    "punkik": "in the north",
    "putoss": "boarder, tourist",
    "putsis": "little boat",
    "putuwe": "s/he blows; s/he spouts",
    "qahaks": "quahog",
    "qahtol": "quarter-hour; quarter",
    "qapsis": "bead",
    "qaqeku": "h/ clothing is dirty or soiled; s/he is dirty, is soiled",
    "qaqeyu": "s/he, it is dirty",
    "qasamu": "s/, it falls away",
    "'qatey": "h/ shin guard",
    "qatsis": "quart bottle",
    "qolapu": "s/he avoids eye-contact, averts gaze",
    "qonapu": "s/he sees that far",
    "qoneyu": "s/he, it is so long",
    "qoniye": "s/he goes so far; s/he goes for so long a time, is gone for so long a time",
    "qonome": "h/ pace is so long",
    "qonotu": "s/he takes so long to return",
    "qospem": "lake",
    "qotasq": "pool, pond, lagoon",
    "qsihtu": "s/he is respectful",
    "sahkat": "needle, syringe",
    "sahsap": "jellyfish",
    "sahsiw": "fast, quickly, rapidly, swiftly",
    "'samel": "there is too much of h/, there is excess of h/;  there are too many of them",
    "samopu": "s/he abuts or touches",
    "sanahq": "halibut",
    "'sanku": "thirteen",
    "sapeyu": "s/he is extremely sensitive to touch; s/he is sore, tender",
    "sapisu": "s/he is hypersensitive to pain; s/he reacts to any touch as if it were painful",
    "sapiye": "s/he, it passes through, goes or comes through;  it turns out or happens",
    "sapsis": "little shop, convenience store",
    "sascis": "sausage",
    "satins": "sardine",
    "sesocu": "s/he is so cold that s/he cries",
    "siciye": "s/he, it goes up to something",
    "sihpac": "pail, bucket",
    "sikeyu": "it is hard to do, is difficult",
    "sikiku": "s/he is stubborn, is fierce, is tough on others",
    "sikopu": "s/he is hard to get at",
    "sikusq": "widow; beetle; pear",
    "'silom": "s/he paddles alone",
    "sinkan": "sinker",
    "'sinsk": "thirty",
    "sipine": "s/he dies hard",
    "sipkiw": "for a long time",
    "sipsis": "bird",
    "siqehe": "s/he, it is emptying, is empty",
    "siqepu": "s/he is empty",
    "siqeyu": "s/he, it is empty",
    "'sisoq": "h/ eye; h/ face",
    "sisqey": "eyeglasses;  monocle, catcher's or goalie's mask",
    "sitopu": "s/he sits close",
    "skewte": "s/he gets mad easily, has quick temper",
    "skikte": "it fits snugly",
    "skipoq": "green leaf",
    "skitap": "man",
    "skitte": "it is on top, it is on surface",
    "skomeq": "female fish",
    "skonis": "bone",
    "skucis": "pumpkin",
    "skutik": "on or along St. Croix River ; at, to Schoodic Point, Gouldsboro, Maine",
    "soluhp": "sloop, shallop; sailing ship, sailboat",
    "somahk": "smock",
    "'somal": "s/he feeds h/",
    "soment": "cement",
    "'somol": "h/ daughter-in-law, h/ grandson's wife",
    "somsoq": "upstairs",
    "soniku": "s/he blows nose",
    "sonopu": "s/he is tight",
    "sopacu": "s/he freezes along edge;  water freezes along h/ edge",
    "soqehs": "weasel, ermine",
    "'soqon": "h/ tail",
    "sossoq": "saliva, spittle",
    "spahte": "it is tall; it is in high place",
    "spemuk": "high in sky, in outer space, up as high as one can see",
    "spessu": "s/he is unintentionally involved in incident with others",
    "spihpu": "s/he eats expensive food",
    "spiqiw": "upward",
    "spotew": "in the daytime, during the day",
    "spuhse": "s/he rises high",
    "sqahte": "it is left over, it is available for future or emergency use",
    "sqasis": "small squash",
    "sqawsu": "s/he survives",
    "sqayiw": "along the edge",
    "sqotes": "spark; ember, glowing coal, live coal",
    "suhpin": "pint; pint jar or bottle; large ladle",
    "'sulom": "s/he gets or has three points;  they are three in a boat, they travel three in a boat",
    "sumsqe": "s/he spits",
    "supeyu": "it is smooth",
    "tahalu": "like, as",
    "taktal": "doctor, physician",
    "talsol": "dulse",
    "tamahc": "here and there;  thereabouts",
    "tampok": "at the garbage dump",
    "tan-al": "somehow, somewhere; in a manner or place unknown",
    "tan-op": "would somehow;  how would ...?",
    "'taptu": "s/he leaves tracks from there, leaves tracks behind",
    "'taqte": "it sticks out from there",
    "'tawsu": "s/he survives, lives through; s/he comes out alive",
    "tayuwe": "when",
    "tepiye": "there is enough of h/, it; there is sufficient or adequate supply of h/, it",
    "tepkil": "s/he is big enough",
    "tepute": "s/he loads items into boat or vehicle",
    "tihkon": "deacon",
    "tkamke": "it is cold to the touch",
    "tkekon": "it is cold;  it is cool, it is suitable to wear in hot weather",
    "tkiqol": "s/he is heavy",
    "tkiqon": "it is heavy; it is a grave or serious matter",
    "tkopeq": "cold spring; cold water",
    "'tohom": "s/he swims from there",
    "'tokan": "s/he hits with it",
    "tolehp": "playing card",
    "toliku": "s/he is growing",
    "tolute": "s/he is moving",
    "tomeyu": "s/he, it is broken",
    "tomiye": "s/he, it breaks in two, breaks apart, breaks off",
    "toposu": "s/he dodges, gets out of the way, ducks",
    "'topun": "h/ spot; h/ bed",
    "toqehs": "twin",
    "toqoss": "marker, playing piece; checker; pawn",
    "tpinom": "s/he watches attentively, stands guard",
    "tuceyu": "s/he is of certain age, s/he is so old",
    "tuciye": "s/he, it goes by; s/he, it goes so fast",
    "tuhkis": "mouse",
    "tuhsan": "shed",
    "tukocu": "s/he wakes up cold",
    "'tuliw": "s/he has boat or canoe",
    "'tuloq": "h/ boat",
    "tupqan": "earth, ground, soil, dirt",
    "'tusal": "s/he operates on h/",
    "'tusiw": "s/he has daughter; s/he is parent of daughter",
    "'tusol": "h/ daughter",
    "tuthom": "s/he swims by, swims past",
    "tutkil": "s/he is so big",
    "tutopu": "s/he is so far along; s/he is sitting at certain distance, is at certain location",
    "tuwapu": "s/he looks in or out",
    "tuwopu": "s/he is in there",
    "ulimal": "s/he makes up with h/, makes amends to h/, apologizes to h/; talks to h/ pleasantly, pleads with h/",
    "uliyal": "s/he cleans h/ when harvesting h/",
    "uniyas": "moss; old man's beard",
    "utomil": "oatmeal",
    "utonal": "s/he obtains h/, gets h/; s/he takes some of h/",
    "walcoq": "swamp, bog, wetland",
    "waleyu": "s/he, it is indented, is dented",
    "waliye": "s/he, it is hollow, is concave",
    "wapatq": "whitecap",
    "wapeyu": "s/he, it is white",
    "wapikp": "ash wood with whitish color",
    "wapiqe": "h/ face is white or pale",
    "wastes": "snowflake",
    "wetsok": "in direction from which wind is blowing, to windward",
    "weweyu": "s/he has regular ways, regular habits; h/ behavior is correct or proper",
    "wewisu": "s/he finds out, investigates",
    "wewiye": "s/he is found out; s/he knows where s/he is going",
    "wicike": "s/he lives in same building with other; s/he is roommate or housemate",
    "wiciye": "s/he goes along, participates, attends;  s/he receives communion",
    "wihton": "h/ nose; h/ bill, h/ beak",
    "wikamu": "s/he falls often",
    "wikiye": "s/he goes frequently; s/he likes to go places",
    "wipahq": "pith or center of stem",
    "wiphun": "feather",
    "wiqhom": "s/he pulls, pulls away; s/he pulls away from previous position",
    "wiqqot": "the tide goes out; it is ebb tide",
    "wisaye": "s/he hurries, goes hurriedly",
    "wisayu": "s/he is in a hurry, in a rush",
    "wisqon": "h/ wrist",
    "wissul": "medal",
    "witkul": "h/ eyebrow",
    "wiyuhs": "meat",
    "wokahk": "h/ scalp",
    "wolacu": "s/he is gearing up, is getting ready, is preparing",
    "wolahq": "fish scale",
    "wolaku": "yesterday",
    "wolame": "s/he is right or correct",
    "wolamu": "s/he, it goes straight; s/he is strike",
    "wolapu": "s/he sees well, has good eyesight; s/he has unobstructed view",
    "woleyu": "s/he is well off, affluent; s/he lives well, lives in comfort, is easy-going; s/he is in good shape, is in good situation",
    "woliku": "s/he is good; s/he is beautiful",
    "woliye": "s/he, it functions well; it shoots accurately;  s/he leads a good life;  very well, it's all right",
    "wolkil": "s/he is nice and big",
    "woloka": "s/he dances well",
    "wolone": "s/he holds good hand",
    "wolopu": "s/he is sitting nicely, comfortably; s/he is well off",
    "wolosu": "s/he has gone to bed",
    "woluwe": "s/he has nice hair;  s/he has nice fur",
    "wonaku": "s/he gets up",
    "wososs": "nest",
    "wotkul": "h/ knee",
    "yakahp": "unless",
    "yat-te": "each and every one individually",
    "yet-te": "each one individually",
    "yut-te": "this, this one",
    "aciye": "s/he moves to different location, changes location",
    "acomu": "s/he tells a story, tells what happened",
    "ahahs": "horse",
    "ahkiq": "seal",
    "ahpap": "rope, cord",
    "akson": "ox;  oxcart",
    "alosu": "s/he sweats",
    "aluhk": "cloud",
    "amkis": "sand",
    "anqoc": "sometimes",
    "apame": "s/he is back from having gone fishing",
    "apesu": "s/he is paid salary or wages",
    "askat": "skirt",
    "atacu": "s/he gets ready again",
    "athom": "s/he swims to different location or place",
    "atiyu": "good-bye, farewell, adieu",
    "atopu": "s/he shifts position in seat",
    "atute": "s/he changes residence, moves belongings to another place, relocates, resettles",
    "atuwe": "s/he sheds hair or fur, molts;  s/he loses baby hair",
    "awotu": "s/he, it is worth something",
    "cayis": "beam; railroad tie",
    "'ceht": "gristle, cartilage",
    "celte": "it is in out-of-the-way place, is inaccessible",
    "cikon": "apple",
    "cikte": "it is quiet, is silent",
    "cimse": "s/he uses boat to gather driftwood along shore",
    "'cine": "s/he dies from",
    "cinpe": "it sits low in water;  the level of liquid in h/ is low",
    "cinte": "it sits low",
    "'ciye": "s/he, it comes back from there, returns from there, has been there",
    "conte": "it is not moving;  it is parked;  it is moored or anchored",
    "cossu": "s/he has color",
    "cotte": "it is colored",
    "cupte": "it sits in water, is partly in water",
    "ehpit": "woman",
    "eksku": "s/he sneezes",
    "eluwe": "almost, nearly",
    "emqan": "spoon",
    "eniqs": "ant",
    "eqopu": "s/he stops sitting",
    "esocu": "s/he is chilled to bone;  cold comes through h/",
    "essap": "clam chowder",
    "halon": "horn; rattle",
    "hapol": "rough utilitarian building used for storage of tools, horse-fodder, etc. , shack",
    "ihhit": "where s/he stays",
    "ihtek": "its place, the place where it belongs, the place where it sits",
    "imiye": "s/he prays",
    "itasu": "it is said",
    "kaciw": "secretly; in hidden or secluded place",
    "kahpe": "coffee",
    "kalsu": "s/he hides",
    "kalus": "diamond",
    "kamel": "camel",
    "kapsq": "waterfall, falls; rocky river bed with rocks exposed so that the water is boiling",
    "kateq": "not at all, nothing at all",
    "katok": "than, as; rather than, instead of",
    "katsu": "s/he hides things; s/he hides",
    "katte": "it is hidden, concealed",
    "kawis": "bur, thistle;  burdock",
    "kawwe": "s/he has spiky or spiked hair",
    "kcihq": "woods, forest",
    "kciye": "s/he, it is pure, unmixed, unadulterated",
    "kehsu": "there is so much of h/;  they are so many, there are so many of them",
    "kensa": "cancer",
    "kepek": "in, to Quebec",
    "kesin": "kerosene, heating oil",
    "kette": "it is off, it has been removed",
    "kihke": "s/he plants, gardens",
    "kilun": "we, us; our, ours; you and I, you and me, yours and mine, etc.; you and we, you and us, yours and ours, etc.",
    "kinap": "brave man, warrior, protector",
    "kinaq": "at least",
    "kippu": "s/he has fallen to ground;  s/he has been felled",
    "kisqe": "s/he forecasts the weather",
    "kiste": "it is finished, ready, completed, done",
    "'kiye": "s/he sets",
    "kollu": "name of a monster in form of giant bird",
    "kolte": "it is on, it is stuck on",
    "komac": "very; very much",
    "kompe": "it floods",
    "komte": "it sits all the way in",
    "kotok": "other, another",
    "kpiye": "s/he goes uphill, upriver; s/he goes up from water onto land",
    "ksate": "it is very hot",
    "ksehe": "s/he, it comes in, goes in, enters",
    "ksicu": "s/he is badly scratched, painfully scratched",
    "ksiku": "s/he is ugly",
    "ksiye": "s/he, it stings, hurts",
    "kuhus": "cow",
    "kuhut": "bed",
    "kukec": "game-warden, policeman;  person who is it;  totem",
    "kulon": "cord",
    "kuwes": "white pine",
    "lahke": "s/he throws; s/he lets go",
    "lalke": "s/he digs thus",
    "lamiw": "inside, underneath",
    "laput": "telescope, microscope, rifle scope;  binoculars",
    "lawiw": "it is against the law",
    "lawsu": "s/he lives there; s/he relies on the food there",
    "lessu": "it happens; something happens to it",
    "letis": "lady",
    "lihpu": "s/he eats thus",
    "likew": "poor little thing!",
    "likon": "it looks thus; it is such and such a kind",
    "lintu": "s/he sings, s/he sings thus",
    "loqsu": "s/he sleeps thus",
    "luhke": "s/he works; s/he does",
    "luhse": "s/he walks there, walks thus",
    "lupap": "rhubarb",
    "mahal": "s/he eats h/",
    "malom": "finally, at last; eventually",
    "maltu": "sledge-hammer",
    "malus": "hop-hornbeam, ironwood",
    "mawew": "gathering, coming together, moving toward central point",
    "mawiw": "together; in group, as group",
    "mayel": "mile",
    "mehqe": "s/he moans, groans",
    "memte": "it fits in place, there is room for it",
    "meqte": "it is positioned carelessly or sloppily; it is easily knocked over or broken, etc.;  it is easy to steal",
    "mesqa": "not yet",
    "metka": "s/he stops dancing, has finished dancing",
    "mette": "it ends there",
    "micin": "s/he eats it",
    "miciw": "blocking, obstructing, in the way",
    "mikut": "thorn",
    "milal": "s/he gives to h/",
    "milan": "s/he gives it to h/",
    "milsu": "s/he gives  to self",
    "milte": "it consists of various items or components",
    "mimey": "grease, oil",
    "minus": "thorn, thorny plant",
    "mitsu": "s/he eats",
    "mitte": "it is in the way, it obstructs",
    "miwiw": "at a distance",
    "miyaw": "exactly; just the one",
    "miyul": "mule",
    "mokos": "soot",
    "moqin": "it swells, it is swollen",
    "mosin": "machine, engine, appliance",
    "mosop": "back side of h/ hip; h/ lower back; place of contact when s/he sits down",
    "mqeyu": "s/he, it is red",
    "muhsu": "tree-worm, borer",
    "mukon": "wood louse, sow bug, pill bug",
    "musal": "s/he cuts h/ hair, gives h/ haircut",
    "musku": "s/he comes up out of water",
    "muste": "not even",
    "muwin": "black bear",
    "naksq": "young woman;  maiden, virgin;  h/ female helper or caregiver",
    "napsq": "male bear",
    "naste": "it is on;  it is being worn",
    "nawiw": "among",
    "nehse": "s/he takes a breath",
    "nekom": "he, she; him, her; his, hers",
    "neqiw": "underneath;  down under",
    "nilun": "we, us ; our, ours",
    "nipon": "it is summer",
    "nisiw": "together, both",
    "nitok": "you're right, I guess so, you may have something there, it's true",
    "nonom": "s/he knows, is knowledgeable; s/he has wits",
    "nopim": "h/ water, h/ liquid",
    "notta": "that one; him!, her!",
    "ntama": "no",
    "nutew": "out; going out, coming out",
    "nutom": "s/he hears",
    "okile": "bark",
    "okisu": "s/he reads, s/he counts",
    "olhom": "s/he swims there",
    "oliye": "s/he goes there",
    "olkil": "s/he is so big; s/he is of certain size",
    "olome": "s/he takes pace",
    "olomu": "s/he, it stands up straight",
    "opote": "it is warm to the touch",
    "oqehe": "s/he lands, arrives by boat where water is shallow , s/he runs canoe ashore; s/he arrives by train, bus, car",
    "oqons": "double-crested cormorant, shag",
    "ososq": "mud, mudflat; stove ashes mixed with water",
    "osson": "fizz, carbonation",
    "otoku": "s/he is in there, s/he remains there; s/he is in jail",
    "otuhk": "deer, whitetail deer",
    "pahpu": "s/he jokes;  s/he plays",
    "pasqe": "it is noon",
    "patus": "bateau, ferry boat",
    "payis": "pie",
    "pehke": "shed",
    "pette": "it extends to there, reaches there",
    "pihce": "long ago",
    "piktu": "s/he farts, breaks wind, passes gas",
    "piley": "new one",
    "piliw": "recently",
    "pisiw": "into; in or out through boundary",
    "piste": "it is in, it has been inserted",
    "pokan": "nut",
    "polis": "briefcase, valise, attachÃ© case",
    "poliw": "elsewhere, somewhere else",
    "polun": "balloon",
    "popiq": "flea",
    "possa": "too",
    "pqeku": "s/he is dressed in red;  s/he is red",
    "pqeyu": "s/he, it is red",
    "pqolu": "h/ bark comes off easily",
    "pseku": "s/he is continuous sheet, is seamless",
    "psqoc": "tree stump",
    "psulu": "s/he chokes",
    "pukan": "bow gun; crossbow",
    "puniw": "in the winter",
    "punke": "s/he spends the winter",
    "pusol": "bushel",
    "puspe": "it is wet, is damp",
    "putep": "whale",
    "qasku": "s/he runs",
    "'qayu": "s/he is angry",
    "qihiw": "near, close to, next to, by",
    "qiqsu": "s/he whistles",
    "qocom": "the outdoors",
    "qoniw": "meanwhile, all during that time, all the while",
    "qonus": "pickerel",
    "sakom": "chief;  band chief;  tribal governor",
    "'sami": "because",
    "samte": "it abuts or touches",
    "sapan": "porridge",
    "sapiw": "through",
    "sapol": "shovel",
    "sases": "saucer",
    "'satq": "three-hundred",
    "sawew": "often",
    "saypa": "zero",
    "sehke": "s/he stands, stands up",
    "seksu": "s/he is scared, is afraid",
    "sepay": "this morning",
    "seqqe": "s/he is eclipsed;  there is an eclipse",
    "siciw": "touching, up against, adjacent to, attached to, very close to",
    "sihku": "sheldrake, merganser",
    "sikon": "scalp",
    "sikte": "it is hard to get to, is hard to get at",
    "simis": "slip",
    "siptu": "s/he has stamina, has endurance",
    "sipun": "black fly",
    "siqey": "empty container",
    "siqon": "it is spring",
    "sitom": "shore, beach, coast;  bank",
    "sokku": "s/he vomits",
    "sonte": "it is Sunday; it is a week",
    "spasu": "s/he is awake; s/he holds vigil over body of someone who has died",
    "speyu": "it is tall, is high",
    "spiye": "s/he, it goes high, becomes tall",
    "spopu": "s/he sits up high, has a high position",
    "spote": "it is daylight",
    "spuls": "spool",
    "sqiye": "s/he, it is left over",
    "sqopu": "s/he is left over, s/he is available for future or emergency use",
    "steks": "stake",
    "sukol": "sugar",
    "sumin": "raisin",
    "supeq": "sea, ocean; salt water",
    "suwiw": "out in the middle of an open area",
    "suwon": "bog cranberry",
    "suwwe": "s/he holds wings outstretched without flapping them",
    "'taku": "s/he is in mourning",
    "'tapu": "s/he looks from there",
    "'tawe": "s/he knows how to talk",
    "tepel": "there is enough of h/",
    "tepiw": "in, inside",
    "tepot": "nevertheless, however, but; therefore, so, consequently, as a result",
    "teppu": "s/he sits in, is in ; s/he sits on toilet",
    "tepte": "it sits in",
    "tkeyu": "s/he is cold to the touch",
    "tkiye": "s/he, it cools, cools down",
    "tkune": "s/he is sluggish from lack of sleep",
    "tokec": "if;  now",
    "tokku": "s/he jumps, leaps",
    "toley": "person from there, resident;  garment that is a perfect fit as if made to order",
    "toqaq": "last fall, last autumn",
    "tpuhk": "late at night",
    "tqamu": "s/he, it moves rapidly upward, flies upward",
    "tqesu": "s/he is ashamed, is embarrassed",
    "tuciw": "moreover, besides; right away; since",
    "tuhpe": "s/he contains liquid",
    "tuhte": "it is in there;  it is loaded",
    "tuton": "it is so far away, it is at certain distance",
    "tutsu": "s/he is located at certain distance",
    "tutte": "it is located at a certain distance",
    "upiye": "s/he comes in repeatedly",
    "utsal": "s/he cuts piece from h/",
    "uwhem": "pet",
    "uwosu": "s/he warms self",
    "wahcu": "s/he is seldom or rarely seen",
    "wahse": "s/he shines a light",
    "wakon": "bait",
    "walke": "s/he digs",
    "walot": "plate, dish, bowl",
    "wansu": "s/he is trusting, tame",
    "wapap": "wampum, wampum belt",
    "wapqe": "s/he has gray hair",
    "wapsq": "polar bear",
    "wasis": "child, baby",
    "wawon": "egg",
    "welam": "so that, in order that",
    "wenaw": "who, someone; someone unknown",
    "wewte": "it is in order, it is arranged correctly",
    "wiciw": "together with",
    "wihke": "s/he builds house",
    "wikke": "s/he builds houses for living",
    "wikut": "camping place",
    "wilol": "h/ tongue",
    "winas": "tripe, stomach lining",
    "winis": "bone marrow",
    "wipit": "h/ tooth",
    "witka": "s/he goes to a dance, dances with others",
    "witte": "it is with",
    "wolek": "diaper; breechcloth, loincloth;  flap of birchbark under gunwale at bow of canoe, which protects ends of gunwale wrappings and also bears canoe-maker's mark",
    "woliw": "immediately, right away",
    "woloq": "h/ armpit",
    "woqon": "h/ heel",
    "wotop": "split spruce root for binding or tying",
    "wotoq": "h/ forehead",
    "wotta": "this one",
};

